
import React from 'react';

export default function TeamShortTermGoalsInformationPage1() 
{
    return ( 
        <> 
            This is where we answer two critical questions:

            <ol>
                <li>What are we working on?</li>
                <li>Who is doing what?</li>
            </ol>

            <p>We recommend Short-Term Goals (example: 1 or 2 weeks in duration) because it's much easier to measure
               how you're team is performing and more quickly identify issues that block forward progress. </p>
            
            <p>We also recommend you use this view to meet regularly (every couple days) with your team members 
               so they can coordinate their activities between themselves. These check-ins work best when kept short 
               (10-15 minutes max).</p>

            <p>The list of assigned Team Actions by Assignee is below. These Actions are also displayed in each 
               Assigned User's Short List. Un-assigned Actions are in the Team Action List (one navigation icon to your left)</p>

        </> 
    );
}
